import * as yup from 'yup';

export const collectionValidationSchema = yup.object({
    collectionName: yup.string().required('Collection name is required'),
    questions: yup.array().of(
        yup.object().shape({
            question: yup.string().required('Question is required'),
            questionType: yup.string().required('Question type is required'),
            attribute: yup.string().required('Attribute is required'),
            group: yup.string().max(100, 'Group must be 100 characters or less'),
            validAnswers: yup.array().of(yup.string().trim()),
        })
    ),
});
